<template>
	<div>
	<div class="self headFixed resetPhone">
		<div class="lucky">
		  <div class="goBack"><img src="../../assets/images/fanhui2.png" @click="$router.go(-1)" class="goBackBtns"></div>
		  <div class="titles">修改手机</div>
		</div>
		<div class="zw-height"></div>
		<div class="container">
			<ul class="panel inputGroup">
				<li>
					<span class="icon-phone icon"></span>
					<input type="text" placeholder="请输入新手机号" v-model="phonenumber" />
				</li>
				<li>
					<span class="icon-ma icon"></span>
					<input type="text" placeholder="请输入验证码" class="" v-model="code" />
					<span class="get_pwd" @click="get_pwd()">{{ this.intervalText }}</span>
				</li>
			</ul>

			<div class="btn_group">
				<mt-button size="large" class="btn-orange" @click="resetMobile">确定</mt-button>
				<router-link to="/personal"><mt-button size="large" class="btn-liner-orange" plain>取消</mt-button></router-link>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
import { Toast } from 'mint-ui';
export default {
	name: 'self',
	data() {
		return {
			phonenumber: null,
			code: null,
			intervalText: '点击获取验证码'
		};
	},
	methods: {
		get_pwd() {
			if (this.phonenumber) {
				if (!this.timer) {
					var time = 60;
					this.intervalText = time + '秒后重新获取';
					this.timer = setInterval(() => {
						time--;
						this.intervalText = time + '秒后重新获取';
						if (time <= 0) {
							this.intervalText = '重新获取';
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000);
					let params = {};
					params.phonenumber = String(this.phonenumber);
					params.type = "PHONENUMBER";
					this.Api.sendSms(params);
				}
			} else {
				Toast('请输入正确的手机号');
			}
		},
		resetMobile() {
			var params = {};
			if (!this.phonenumber) {
				Toast('请输入手机号');
				return false;
			}
			if (!this.code) {
				Toast('请输入密码');
				return false;
			}
			params.phonenumber = this.phonenumber;
			params.code = this.code;
			this.Api.updateMobilePhone(params, msg => {
				if (msg.code === 200) {
					this.$router.push({
						path: '/personal'
					});
          localStorage.setItem('token', msg.token);
					this.Api.saveInfo();
				} else {
					Toast(msg.message);
				}
			});
		}
	}
};
</script>

<style scoped>
@import url('./../login.css');
.zw-height{
	height: 200px;
}
.resetPhone {
	background-image: url('../../assets/images/re.png');
	/* padding-top:200px; */
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	min-height: 100vh;
	position: relative;
	overflow: hidden;
}
.inputGroup {
	margin-top: 0;
	border: none;
}
.inputGroup input {
	border-bottom: none !important;
}
.inputGroup li {
	border-bottom: 1px solid #dcdcdc !important;
}
.lucky {
    text-align: center;
	width: 100%;
	top: 0;
	background-color: transparent;
	border: none;
}

.titles{
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
    font-size: 16px;
    display: inline-block;
    line-height: 44px;
	text-align: center;
	color:#FFFFFF;
}
.goBack{
	width: 44px;
	height: 44px;
	text-align: center;
	line-height: 44px;
}
.goBackBtns {
    width: 22px;
    height: 22px;
	vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/resetPhone.vue